export const downloadExportFile = (file: File, options: { name: string; type: string }) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([file]));
    downloadLink.download = `${options.name}.${options.type.toLowerCase()}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

export const downloadFile = (blob: Blob, fileName: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

// Parses the filename from a Content-Disposition header, preferring the
// RFC 5987 `filename*=UTF-8''...` form (percent-encoded) over plain `filename=`.
export const getFileNameFromContentDisposition = (header?: string): string | undefined => {
    if (!header) {
        return undefined;
    }
    const encodedMatch = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    if (encodedMatch?.[1]) {
        try {
            return decodeURIComponent(encodedMatch[1].trim().replace(/^["']|["']$/g, ''));
        } catch {
            // malformed encoding — fall back to the plain filename below
        }
    }
    const plainMatch = header.match(/filename="?([^";]+)"?/i);
    return plainMatch?.[1]?.trim();
};
